import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../axios/AxiosInstance";
import { apiErrorMessage } from "../utils/apiError";
import {
  WeeklyIndicators,
  CommercialPipeline,
  DailyCard,
} from "../commercial/components/daily/DailyWidgets";
import ClientDetail from "../pages/ClientDetail";
import "../commercial/style.css";
export default function DashboardCommercialSummary() {
  const navigate = useNavigate();
  const [metrics, setMetrics] = useState(null);
  const [clients, setClients] = useState([]);
  const [error, setError] = useState("");
  const [clientError, setClientError] = useState("");
  const [selection, setSelection] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  useEffect(() => {
    let active = true;
    // Les indicateurs ne dépendent pas du téléchargement des fiches clients.
    const refresh = () => axios.get("dashboard/commercial")
      .then(({ data }) => {
        if (!active) return;
        setMetrics(data);
        setError("");
      })
      .catch((error) => {
        if (active)
          setError(apiErrorMessage(error, "Impossible de charger les indicateurs commerciaux."));
      });
    axios.get("client/freelance")
      .then(({ data }) => {
        if (active) setClients(Array.isArray(data) ? data : []);
      })
      .catch((error) => {
        if (active)
          setClientError(apiErrorMessage(error, "Impossible de charger les fiches clients."));
      });
    refresh();
    window.addEventListener("focus", refresh);
    return () => {
      window.removeEventListener("focus", refresh);
      active = false;
    };
  }, []);
  if (error)
    return (
      <p role="alert" className="mb-6 text-sm text-rose-700">
        {error}
      </p>
    );
  if (!metrics)
    return (
      <p role="status" className="mb-6 text-sm text-slate-500">
        Chargement des indicateurs commerciaux…
      </p>
    );
  return (
    <div className="commercial-module mb-6">
      {clientError && <p role="status" className="mb-4 text-sm text-amber-700">{clientError}</p>}
      <div
        className="dailyLowerGrid"
        style={{
          gridTemplateColumns:
            "repeat(auto-fit, minmax(min(100%, 360px), 1fr))",
          alignItems: "start",
        }}
      >
        <WeeklyIndicators actual={metrics.current} previous={metrics.previous} period={metrics.periods?.current} />
        <CommercialPipeline
          state={{ clients: metrics.clients || [], needs: metrics.needs || [], weeklyCandidates: metrics.weeklyCandidates }}
          stages={metrics.stages || []}
          onSelect={setSelection}
        />
      </div>
      {selection && (
        <DailyCard
          title={selection.title}
          action={
            <button className="textAction" onClick={() => setSelection(null)}>
              Fermer
            </button>
          }
        >
          {selection.items.map((item) => (
            <button
              key={item.id}
              className="dailyOpportunity"
              onClick={() => {
                if (selection.kind === "candidates") {
                  if (item.candidateId) navigate(`/candidatsPage?fiche=${encodeURIComponent(item.candidateId)}`);
                  return;
                }
                if (selection.kind === "clients") {
                  const client = clients.find(
                    (client) =>
                      client._id === (item.establishment_id || item.id),
                  );
                  if (client) setSelectedClient(client);
                  else navigate("/actions-commerciales");
                } else navigate("/commandesPage");
              }}
            >
              <b>
                {selection.kind === "clients" || selection.kind === "candidates"
                  ? item.name
                  : metrics.clients.find((client) => client.id === item.clientId)
                      ?.name}
              </b>
              <small>{item.job || item.title || item.status}</small>
            </button>
          ))}
          {!selection.items.length && (
            <p className="dashboardEmpty">
              Aucun élément pour cette sélection.
            </p>
          )}
        </DailyCard>
      )}
      {selectedClient && (
        <ClientDetail
          key={selectedClient._id}
          client={selectedClient}
          setClient={setSelectedClient}
          clients={clients}
          setClients={setClients}
          originalClients={clients}
        />
      )}
    </div>
  );
}
